import React from "react";
import Coins from "../../assets/images/icons/coins.svg";
import InvoiceTypeCard from "./invoice-type-card";
import { connect } from "react-redux";
import { history } from "../../_helpers";

const EntitySelectionCard = ({ setEntityType }) => {
  const cardContents = [
    {
      type: "organization",
      icon: require("../../assets/images/icons/organization-icon.svg"),
      title: "Cooperate",
      subtitle:
        "For businesses trying to raise invoices for operational services",
    },
    {
      type: "individual",
      icon: require("../../assets/images/icons/person-icon.svg"),
      title: "Individual",
      subtitle:
        "For individuals trying to raise invoices for one-time services",
    },
  ];
  const handleProceed = (type) => {
    if (type === "organization") {
      setEntityType("organization");
    } else {
      sessionStorage.setItem("entityType", "individual");
      window.location.href = "/invoice-initation";
    }
  };

  return (
    <div className="invoice-creation-content">
      <div className="icon-wrapper">
        <img src={Coins} alt="Search Logo" />
      </div>
      <p className="invoice-text title"> Select which applies to you </p>
      <div className="invoice-card-container">
        {cardContents.map((cardContent, index) => (
          <InvoiceTypeCard
            key={index}
            type={cardContent.type}
            icon={cardContent.icon}
            title={cardContent.title}
            subtitle={cardContent.subtitle}
            onClick={handleProceed}
          />
        ))}
      </div>
    </div>
  );
};

export default EntitySelectionCard;
